import { useQuery } from '@tanstack/react-query';
import { createSubscriptionQuery } from 'shared/lib/@tanstack-query';
import { getLifeAreas, GetLifeAreasOptions } from 'shared/services/backend-api';
import { ID } from 'shared/types/id';
import { chunkArray } from 'shared/utils/chunk-array';

export const queryKey = 'life-areas';

export const useLifeAreasQuery = (
  uid?: ID,
  options: GetLifeAreasOptions = {},
  enabled = true,
) =>
  useQuery({
    queryKey: [
      queryKey,
      uid ?? '',
      enabled.toString(),
      ...Object.entries(options)
        .filter(([, value]) => value !== undefined)
        .map(
          ([key, value]) =>
            `${key}: ${
              value.toSorted().join(',')
              // value instanceof Date
              //   ? value.getTime().toString()
              //   : Array.isArray(value)
              //   ? value.join(',')
              //   : value?.toString()
            }`,
        ),
    ],
    queryFn: (context) => {
      if (!enabled) {
        return [];
      }

      const { ids, ...rest } = options;
      let queries = [() => getLifeAreas(options)];

      if (ids?.length && ids.length > 30) {
        // chunk to max-length of 30 since firebase doesn't accept more
        const chunkedIds = chunkArray(ids.toSorted(), 30);
        queries = chunkedIds.map(
          (chunked) => () => getLifeAreas({ ...rest, ids: chunked }),
        );
      }

      return createSubscriptionQuery(queries)(context);
    },
    enabled: !!uid && enabled,
  });
